.app-store-badge {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 9px 18px;
  background: #000;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 11px;
  text-decoration: none;
  line-height: 1;
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.app-store-badge:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.app-store-badge svg {
  flex-shrink: 0;
}

.app-store-badge-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: 0.01em;
}

.app-store-badge-text small {
  font-size: 0.62rem;
  font-weight: 400;
  letter-spacing: 0.03em;
  opacity: 0.9;
}
